import type { BrownfieldBridgeInternalSetupParams } from './internalTypes'
import type { BrownfieldBridgeEvent, KeepAliveTimingConfig } from './types'

export function setup(_params: BrownfieldBridgeInternalSetupParams) {
  return () => {}
}

export function reconnectBridge() {
  // No-op for web platform
}

const DEFAULT_KEEPALIVE_TIMING: KeepAliveTimingConfig = {
  userInteractionThrottleMs: 3000,
  videoCallKeepaliveIntervalMs: 3000,
  navigationKeepaliveIntervalMs: 3000,
}

export async function getKeepAliveTimingConfig(): Promise<KeepAliveTimingConfig> {
  return DEFAULT_KEEPALIVE_TIMING
}

export async function getExchangeToken(): Promise<string> {
  return ''
}

export async function getPushToken(): Promise<string | null> {
  return null
}

export async function getVoipPushToken(): Promise<string | null> {
  return null
}

export async function getEmbeddedBrandVersion(): Promise<string | null> {
  return null
}

export function startMediaKeepAlive(): void {}

export function stopMediaKeepAlive(): void {}

export function triggerEvent(_event: BrownfieldBridgeEvent) {}

export function popToNative() {}
